import * as firebase from "firebase";
import 'firebase/auth';

// const config = ({
//     apiKey: "AIzaSyA8Z8dVQiTRJoRpx0X7GNwoY2MWaGlSros",
//     projectId: "p0071-dev",
//     authDomain: "p0071-dev.firebaseapp.com",
//     storageBucket: 'gs://p0071-dev.appspot.com',
//     databaseURL: 'https://p0071-dev.firebaseio.com',
// });

const config = ({
    apiKey: process.env.REACT_APP_API_KEY,
    projectId: process.env.REACT_APP_PROJECTID,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN
});

export const firebaseApp = firebase.initializeApp(config);
export const auth = firebaseApp.auth();

